import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ContentReview from "@/components/ContentReview";
import { api, formatApiErrorDetail } from "@/lib/api";
export default function Admin() {
  const [tests,setTests]=useState([]);
  const [error,setError]=useState("");
  const load=async()=>{
    try {setTests((await api.get('/admin/tests')).data);setError("");}
    catch(e){setError(formatApiErrorDetail(e.response?.data?.detail));}
  };
  useEffect(()=>{load();},[]);
  return <main className="max-w-6xl mx-auto px-6 py-16">
    <p className="caption mb-6">Administrace</p>
    <h1 className="font-serif text-4xl mb-4">Čeština pro osmiletá gymnázia</h1>
    <p className="text-slate mb-5">Testy jsou dostupné ve zkušebním provozu. Zde můžeš kontrolovat obsah a ručně ohodnotit vlastní věty. Schválení obsahu potvrď až po skutečné odborné kontrole.</p>
    <Link to="/testy" className="inline-block text-navy underline mb-10">Otevřít testy jako řešitel →</Link>
    {error && <p role="alert" className="text-red-800 mb-6">{error}</p>}
    <ContentReview tests={tests} onSaved={load}/>
    <h2 className="font-serif text-2xl mb-4">Banka testů ({tests.length})</h2>
    <ul className="divide-y divide-stone">{tests.map(t=><li key={t.id} className="py-4"><p className="font-serif text-xl">{t.title}</p><p className="text-sm text-slate">{t.question_count} úloh · {t.max_score} bodů · {t.time_limit_minutes} minut · {t.status==='published'?'Schválený obsah':'Pracovní obsah'}</p></li>)}</ul>
  </main>;
}
